import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import interfaceArrowsButtonRight from '../../../images/global//interface-arrows-button-right.svg'

import Link from '../../Link'
import Svg from '../../SVG'
import Background from '../../Background'

const ForcesHero = ({
    items: _items,
    forcesHeroItems,
    primary: _primary,
    forcesHeroPrimary,
}) => {
    const primary = forcesHeroPrimary || _primary
    const items = forcesHeroItems || _items

    return items?.length > 0 ? (
        <div className="md:flex-row-reverse md:h-screen-4/5 relative flex flex-col w-full">
            <div className="pt-9/16 relative flex-1 pt-0">
                <div className="md:h-screen-4/5 absolute top-0 left-0 w-full h-full">
                    <Background
                        fluid={primary?.background_image?.fluid}
                        className="absolute top-0 left-0 z-0 w-full h-full bg-bottom bg-cover"
                        style={{ position: 'absolute!important' }}
                    />
                    <span className="bg-navy absolute top-0 left-0 block w-full h-full opacity-50" />

                    {primary?.heading ? (
                        <h1 className="md:max-w-3xl md:px-12 bottom-8 md:bottom-12 left-1/2 md:text-3xl lg:text-4xl absolute z-20 w-full max-w-md px-8 text-2xl font-semibold text-center text-white transform -translate-x-1/2">
                            {primary?.heading}
                        </h1>
                    ) : null}
                </div>
            </div>
            <div className="flex-0 md:w-56 lg:w-128 bg-navy flex flex-col w-full h-full">
                {items?.map(
                    (
                        {
                            armed_force: {
                                uid,
                                document: { data },
                            },
                        },
                        i
                    ) => (
                        <Link
                            to={uid}
                            key={i}
                            className="group flex-0 md:flex-1 relative flex items-center h-20 pl-12 pr-8 overflow-hidden"
                        >
                            {data?.accent_colour ? (
                                <span
                                    className="h-double top-1/2 left-4 t group-hover:left-0 group-hover:translate-x-0 absolute block w-full transition-all duration-300 transform -translate-x-full -translate-y-1/2 pointer-events-none"
                                    style={{
                                        backgroundColor: data?.accent_colour,
                                    }}
                                />
                            ) : null}
                            {data?.logo ? (
                                <div className="md:w-32 relative z-10 w-20 text-center">
                                    <div className="max-w-12 md:max-w-24 max-h-10 md:max-h-20 top-1/2 left-1/2 absolute w-full transform -translate-x-1/2 -translate-y-1/2">
                                        <GatsbyImage
                                            image={getImage(
                                                data?.logo?.localFile
                                                    ?.childImageSharp ||
                                                    data?.logo
                                            )}
                                            className="max-w-12 md:max-w-24 max-h-10 md:max-h-20 w-full"
                                            imgStyle={{ objectFit: 'contain' }}
                                            alt="test"
                                        />
                                    </div>
                                </div>
                            ) : null}
                            <div className="md:hidden lg:flex flex items-center justify-end flex-1">
                                <div className="sm:flex group-hover:-translate-x-4 whitespace-nowrap relative z-10 items-center justify-end flex-1 hidden ml-8 text-xs font-bold text-white uppercase transition-all transform">
                                    Browse Products
                                </div>
                                <Svg
                                    src={interfaceArrowsButtonRight}
                                    className="relative z-10 w-3 h-auto ml-4 text-white"
                                />
                            </div>
                        </Link>
                    )
                )}
                {primary?.bottom_label && primary?.bottom_link ? (
                    <Link
                        to={
                            primary?.bottom_link?.uid === 'home'
                                ? '/'
                                : primary?.bottom_link?.uid
                        }
                        className="group flex-0 md:flex-1 relative flex items-center h-20 pl-12 pr-8 overflow-hidden"
                    >
                        <span className="h-double top-1/2 left-4 group-hover:left-0 group-hover:translate-x-0 bg-grey absolute z-0 block w-full transition-all duration-300 transform -translate-x-full -translate-y-1/2 pointer-events-none" />
                        <span className="md:w-auto md:max-w-xs md:text-2xl lg:text-4xl md:text-center lg:text-left relative z-10 block w-32 text-xl font-bold leading-none text-left text-white uppercase">
                            {primary?.bottom_label}
                        </span>
                        <div className="md:hidden lg:flex flex items-center justify-end flex-1">
                            <div className="sm:flex group-hover:-translate-x-4 whitespace-nowrap relative z-10 items-center justify-end flex-1 hidden ml-8 text-xs font-bold text-white uppercase transition-all transform">
                                {primary?.bottom_small_text || 'Contact Us'}
                            </div>
                            <Svg
                                src={interfaceArrowsButtonRight}
                                className="relative z-10 w-3 h-auto ml-4 text-white"
                            />
                        </div>
                    </Link>
                ) : null}
            </div>
        </div>
    ) : null
}

export default ForcesHero
